import { render, staticRenderFns } from "./autocomplete.vue?vue&type=template&id=139b1f87&"
import script from "./autocomplete.vue?vue&type=script&lang=ts&"
export * from "./autocomplete.vue?vue&type=script&lang=ts&"
import style0 from "./autocomplete.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports